import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useSelector } from "react-redux";
import SearchProductModal from "./modal/SearchProductModal";

const RootLayout = () => {
  const searchValue = useSelector((state) => state.search.searchValue);
  return (
    <div>
      <Header />
      <main>
        <Outlet />
        {/* Đặt vào RootLayout để kết quả search có thể hiện lên mọi trang */}
        <div className="homeSearchModal position-absolute">
          {searchValue && <SearchProductModal searchValue={searchValue} />}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RootLayout;
